<template>
  <div>
    <main class="main" @scroll="handleScroll">
      <Banner />
      <Announcement />
      <Overview />
      <Map />
      <Charts />
      <Prefectures />
      <Guide />
      <Consultation />
    </main>
    <Footer />
    <transition name="menu">
      <Menu v-if="!isScrollingDown || isAtTop || isAtBottom" />
    </transition>
    <Spinner :show="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import createOnScrollMixin from '@/mixins/onscroll'
import Spinner from '@/components/Spinner'
import Banner from './components/Banner'
import Announcement from './components/Announcement'
import Overview from './components/Overview'
import Map from './components/Map'
import Charts from './components/Charts'
import Prefectures from './components/Prefectures'
import Guide from './components/Guide'
import Consultation from './components/Consultation'
import Footer from './components/Footer'
import Menu from './components/Menu'

const onScroll = createOnScrollMixin(function () {
  const target = document.scrollingElement
  this.scrollTop = {
    last: this.scrollTop.current,
    current: target.scrollTop,
    max: target.scrollHeight - target.clientHeight,
  }
}, { throttle: 200 })

export default {
  name: 'App',
  mixins: [onScroll],
  data () {
    return {
      scrollTop: {
        last: 0,
        current: 0,
        max: 1,
      },
      loading: false,
    }
  },
  computed: {
    isScrollingDown () {
      return this.scrollTop.current > this.scrollTop.last
    },
    isAtTop () {
      return this.scrollTop.current === 0
    },
    isAtBottom () {
      return this.scrollTop.current === this.scrollTop.max
    },
  },
  methods: {
    ...mapActions(['fetchVisions']),
    handleScroll: function ({ target }) {
      console.log(target)
    },
  },
  async mounted () {
    this.loading = true
    try {
      await this.fetchVisions()
    } finally {
      this.loading = false
    }
  },
  components: {
    Spinner,
    Banner,
    Announcement,
    Overview,
    Map,
    Charts,
    Prefectures,
    Guide,
    Consultation,
    Footer,
    Menu,
  },
}
</script>

<style lang="less" scoped>
.menu-enter-active, .menu-leave-active {
  transition: all 200ms ease;
}
.menu-enter, .menu-leave-to {
  opacity: 0;
  transform: translateY(66px);
}
</style>
